import { ReactComponent as CalendarIconSVG } from '@/assets/icons/CalendarIcon.svg';
import { SVGProps } from 'react';

const CalendarIcon = (props: SVGProps<SVGSVGElement>) => <CalendarIconSVG {...props} />;

export default CalendarIcon;
